var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondaryArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 8.00194L7.62434 8.37825L1.23048 14.7721L0.854174 15.1484L0.101562 14.3958L0.477868 14.0195L6.49543 8.00194L0.477868 1.98439L0.101562 1.60808L0.854174 0.855469L1.23048 1.23177L7.62434 7.62564L8.00065 8.00194Z",
    fill: "#3B6CCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondaryArrow);
export default __webpack_public_path__ + "static/media/Secondary_Arrow.16a632ce26c6c858a786b40254d6f778.svg";
export { ForwardRef as ReactComponent };